export default __webpack_public_path__ + "static/media/slide1.a3951548.png";